import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import type { Article } from "../../data/articles";

const linkClass = "text-slate-400 underline-offset-4 transition-colors duration-200 hover:text-emerald-400 hover:underline";

export function ArticleBreadcrumb({ article }: { article: Article }) {
  return (
    <nav aria-label="Trilha de navegação" data-testid="article-breadcrumb" className="text-xs sm:text-sm">
      <ol className="flex flex-wrap items-center gap-1.5">
        <li><Link to="/" data-testid="breadcrumb-home" className={linkClass}>Início</Link></li>
        <li aria-hidden="true"><ChevronRight className="h-3.5 w-3.5 text-slate-600" /></li>
        <li><Link to={article.nicheUrl} data-testid="breadcrumb-niche" className={linkClass}>{article.nicheLabel}</Link></li>
        <li aria-hidden="true"><ChevronRight className="h-3.5 w-3.5 text-slate-600" /></li>
        <li aria-current="page" className="min-w-0 text-slate-300">{article.title}</li>
      </ol>
    </nav>
  );
}
